import React, { useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import {Button} from '@material-ui/core';
import {
  Checkbox,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Box,
  FormControlLabel
} from '@mui/material';

// const initialOptions = [
//   { id: 1, label: 'Item 1', selected: false, value: '' },
//   { id: 2, label: 'Item 2', selected: false, value: '' },
//   { id: 3, label: 'Item 3', selected: false, value: '' },
// ];

export default function MultiSelectDialog(props) {
  const [options, setOptions] = useState(props.options);
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleCheckboxChange = (id) => {
    setOptions((prev) =>
      prev.map((opt) =>
        opt.id === id ? { ...opt, selected: !opt.selected } : opt
      )
    );
  };

  const handleValueChange = (id, newValue) => {
    setOptions((prev) =>
      prev.map((opt) =>
        opt.id === id ? { ...opt, value: newValue } : opt
      )
    );
  };

  const selectedDisplay = options
    .filter((opt) => opt.selected && opt.value>0)
    .map((opt) => `${opt.id}.${opt.label}: ${opt.value || '-'}`)
    .join(', ') || 'Select Bloom';

  const handleDone = () => {
    const selectedStr = options
    .filter((opt) => opt.selected && opt.value>0)
    .map((opt) => `${opt.id}:${opt.value || 0}`)
    .join(', ');
    props.selectedOptions(selectedStr);
    ///alert(selectedStr);
    handleClose();
  };  

  return (
    <Box>
      <div
        onClick={handleOpen}
        style={{cursor:'pointer'}}
      >
        {selectedDisplay}
        {/* {options?JSON.stringify(options):null} */}
      </div>

      <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
        <DialogTitle>Select Bloom</DialogTitle>
        <DialogContent dividers>          
          {options.map((option) => (
            <Box
              key={option.id}
              sx={{
                display: 'flex',
                alignItems: 'center',
                mb: 2,
                gap: 2,
              }}
            >
              <FormControlLabel
                control={
                  <Checkbox
                    checked={option.selected}
                    onChange={() => handleCheckboxChange(option.id)}
                  />
                }
                label={option.id+". "+option.label}
                style={{width:275}}
              />
              <TextField
                value={option.value}
                onChange={(e) =>
                  handleValueChange(option.id, e.target.value)
                }
                placeholder="Enter value"
                size="small"
                disabled={!option.selected}
                fullWidth
              />
            </Box>
          ))}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {handleClose()}} size="small" variant="outlined" >Cancel</Button>
          <Button onClick={handleDone} variant="outlined" size="small" color="primary" >Done</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
